import React, { forwardRef, Fragment, useEffect, useState } from "react";
import { TransitionProps } from "@mui/material/transitions";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Slide,
  TextField,
} from "@mui/material";
import { checkEmpty, checkIf } from "../../utils";
import { MealTypeResponse } from "../../openapi/client";
import { CrossIcon } from "../../assets/icons";
import { MealSelection, MenuSelectionItems, MenuSelectionValues } from "../../openapi/interfaces";
import InputNumber from "../InputNumber";
import Can from "../Can";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
  open: boolean;
  list: MealSelection;
  onClose: (event: {}, reason?: "backdropClick" | "escapeKeyDown") => void;
  onConfirm: (payload: MealSelection) => void;
}

export default function MealTypeSelector(props: IProps) {
  const getPopulatedSelections = Object.keys(props.list).filter((key) =>
    Boolean(props.list[key as MenuSelectionValues]?.show)
  );

  const [deleteActive, setDeleteActive] = useState(false);
  const [value, setValue] = useState<MealSelection>(props.list);
  const handleClose = (e: React.MouseEvent, reason?: "backdropClick" | "escapeKeyDown") => {
    e.stopPropagation();
    props.onClose(e);
  };

  const limitChange = (value: number, type: MenuSelectionValues) => {
    setValue((state) => {
      return {
        ...state,
        [type]: {
          ...state[type],
          limit: value,
        },
      };
    });
  };

  const handleChange = (event: any, item: MenuSelectionValues) => {
    setValue((state) => {
      return {
        ...state,
        [item]: {
          ...state[item],
          show: !state[item]!.show,
        },
      };
    });
  };

  const handleConfirm = (e: React.MouseEvent) => {
    e.stopPropagation();
    // send only the new selections
    let filter = {};
    Object.entries(value).forEach((item) => {
      if (item[1].show && !getPopulatedSelections.includes(item[0])) {
        filter = { ...filter, [item[0]]: item[1] };
      }
    });
    props.onConfirm(filter);
  };

  // useEffect(() => {
  //   setValue(getPopulatedSelections);
  // }, [props.list]);

  //AddMenuItemRequest

  // console.log("props.list", props.list);
  // console.log("getPopulatedSelections", getPopulatedSelections);
  // console.log("value", value);

  return (
    <Fragment>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.15)",
            padding: "24px",
            maxWidth: "320px",
          },
          "& .MuiDialogTitle-root": {
            padding: "0 16px 16px 0",
          },
          "& .MuiDialogContent-root,& .MuiDialogActions-root": {
            padding: 0,
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "text.dark",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "150%",
          }}
        >
          {"Please select the menus you want to add"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.dark2",
          }}
        >
          <CrossIcon />
        </IconButton>
        <DialogContent>
          <FormControl sx={{ width: "100%" }}>
            <FormGroup>
              {Object.entries(value).map((entry) => {
                const type = entry[0];
                const mealTypeObj = entry[1];
                const disabled = getPopulatedSelections.includes(type);
                const includes = Boolean(mealTypeObj.show);
                return (
                  <Box
                    key={type}
                    sx={{ display: "flex", gap: "4px", alignItems: "center", justifyContent: "space-between" }}
                  >
                    <Can permission="MEAL_PLANNING_CREATE">
                      <FormControlLabel
                        disabled={disabled}
                        className={includes ? "selected" : ""}
                        control={
                          <Checkbox
                            checked={includes}
                            onChange={(e) => handleChange(e, type as MenuSelectionValues)}
                            name={mealTypeObj.id}
                          />
                        }
                        label={mealTypeObj.description}
                        sx={{
                          padding: "12px 0 !important",
                          margin: 0,
                          "& > .MuiButtonBase-root": { padding: 0 },
                          "& > .MuiTypography-root": { fontSize: "14px", fontWeight: "500" },
                          fontSize: "14px",
                          fontWeight: 500,
                          columnGap: "8px",
                        }}
                      />
                    </Can>
                    <Box className="limit-wrap">
                      <InputNumber
                        disabled={disabled}
                        default={mealTypeObj.limit}
                        onChange={(limit) => limitChange(limit, type as MenuSelectionValues)}
                      />
                    </Box>
                  </Box>
                );
              })}
            </FormGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            fullWidth
            color="secondary"
            variant="contained"
            sx={{ display: "flex", flexDirection: "column", marginTop: "8px" }}
            onClick={handleConfirm}
          >
            Add to List
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
